"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Commander Spellbook API
 * API for Commander Spellbook, the combo database engine for Magic: The Gathering
 *
 * The version of the OpenAPI document: 4.8.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuggestionStatusEnum = void 0;
exports.instanceOfSuggestionStatusEnum = instanceOfSuggestionStatusEnum;
exports.SuggestionStatusEnumFromJSON = SuggestionStatusEnumFromJSON;
exports.SuggestionStatusEnumFromJSONTyped = SuggestionStatusEnumFromJSONTyped;
exports.SuggestionStatusEnumToJSON = SuggestionStatusEnumToJSON;
exports.SuggestionStatusEnumToJSONTyped = SuggestionStatusEnumToJSONTyped;
/**
 * * `N` - New
 * * `AD` - Awaiting Discussion
 * * `PA` - Pending Approval
 * * `A` - Accepted
 * * `R` - Rejected
 * @export
 * @enum {string}
 */
var SuggestionStatusEnum;
(function (SuggestionStatusEnum) {
    SuggestionStatusEnum["N"] = "N";
    SuggestionStatusEnum["Ad"] = "AD";
    SuggestionStatusEnum["Pa"] = "PA";
    SuggestionStatusEnum["A"] = "A";
    SuggestionStatusEnum["R"] = "R";
})(SuggestionStatusEnum || (exports.SuggestionStatusEnum = SuggestionStatusEnum = {}));
function instanceOfSuggestionStatusEnum(value) {
    for (const key in SuggestionStatusEnum) {
        if (Object.prototype.hasOwnProperty.call(SuggestionStatusEnum, key)) {
            if (SuggestionStatusEnum[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function SuggestionStatusEnumFromJSON(json) {
    return SuggestionStatusEnumFromJSONTyped(json, false);
}
function SuggestionStatusEnumFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function SuggestionStatusEnumToJSON(value) {
    return value;
}
function SuggestionStatusEnumToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=suggestionStatusEnum.js.map